import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getCurrentUser } from "./authClient";

const AdminRoute = ({ children }) => {
    const [status, setStatus] = useState("checking");

    useEffect(() => {
        let mounted = true;

        const checkAdmin = async () => {
            const data = await getCurrentUser();
            if (!mounted) return;

            if (!data?.email) {
                setStatus("unauthenticated");
            } else if (data?.role === "admin") {
                setStatus("allowed");
            } else {
                setStatus("forbidden");
            }
        };

        checkAdmin();

        return () => {
            mounted = false;
        };
    }, []);

    if (status === "checking") {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-100">
                <div className="rounded-2xl border border-slate-200 bg-white px-6 py-4 shadow-sm">
                    <p className="text-sm text-slate-600">Checking admin access...</p>
                </div>
            </div>
        );
    }

    if (status === "unauthenticated") {
        return <Navigate to="/signin" replace />;
    }

    if (status === "forbidden") {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default AdminRoute;
